module.exports = __webpack_public_path__ + "static/media/INZ1198.ef9cb5cc.pdf";